'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const ServiceHubLogo = props => {
  return /*#__PURE__*/_jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    id: "Layer_1",
    version: "1.1",
    viewBox: "0 0 24 24",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px"
  }, props, {
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("g", {
        children: [/*#__PURE__*/_jsx("path", {
          d: "M1.45901,4.51689L1.45901,4.51689c1.94535-1.94535,5.09937-1.94535,7.04471-0.00001l10.54016,10.54017 l-5.06792,5.06792c-1.09176,1.09176-2.86184,1.09176-3.9536,0l-8.56336-8.56337C-0.48634,9.61627-0.48634,6.46224,1.45901,4.51689 z",
          fill: "#FF7A59"
        }), /*#__PURE__*/_jsxs("linearGradient", {
          gradientUnits: "userSpaceOnUse",
          id: "SVGID_1_",
          x1: "7.99989",
          x2: "22.40414",
          y1: "14.5396",
          y2: "9.54612",
          children: [/*#__PURE__*/_jsx("stop", {
            offset: "3.45%",
            stopColor: "#FF7A59"
          }), /*#__PURE__*/_jsx("stop", {
            offset: "55.512%",
            stopColor: "#FFAC78"
          })]
        }), /*#__PURE__*/_jsx("path", {
          d: "M22.53932,4.51689L22.53932,4.51689c-1.94535-1.94535-5.09937-1.94535-7.04471-0.00001 L4.95445,15.05706l5.06792,5.06792c1.09176,1.09176,2.86184,1.09176,3.9536,0l8.56336-8.56337 C24.48466,9.61627,24.48466,6.46224,22.53932,4.51689z",
          fill: "url(#SVGID_1_)"
        })]
      }), /*#__PURE__*/_jsx("circle", {
        cx: "19.01291",
        cy: "8.0433",
        fill: "#FF7A59",
        r: "4.98709"
      })]
    })
  }));
};

export default ServiceHubLogo;